import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const HubspotSuccess = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");
  const data = searchParams.get("data");

  useEffect(() => {
    // ✅ If opened in popup, notify parent and close
    if (window.opener) {
      window.opener.postMessage({ status, data }, window.location.origin);
      window.close();
    }
  }, [status, data]);

  return (
    <div className="flex items-center justify-center h-screen bg-gray-50">
      <div className="bg-white p-6 rounded-lg shadow-lg text-center max-w-sm">
        {status === "success" ? (
          <>
            <h2 className="text-xl font-bold text-green-600 mb-2">✅Hubspot is connected!</h2>
            <p className="text-gray-700">
              {data ? `${data.replace("-", " ")} has been successfully connected.` : "HubSpot connected successfully."}
            </p>
          </>
        ) : (
          <>
            <h2 className="text-xl font-bold text-red-600 mb-2">❌ Failed</h2>
            <p className="text-gray-700">
              Something went wrong. Please try again.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default HubspotSuccess;
